// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:32
import { TimerSchedule_abstract } from './../../abstract/SagaBase/Objects/TimerSchedule_abstract';
export class TimerSchedule extends TimerSchedule_abstract {}
